const millisToHours = (milliseconds) => {
  const hours = (milliseconds / (1000 * 60 * 60)).toFixed(2);
  return `${hours}h`;
};
export default millisToHours;
